import React from "react";
import "../css/Login.css";
import Button from "@material-ui/core/Button";
import { auth, provider } from "../firebase";
import { actionTypes } from "../Reducer";
import { useStateValue } from "../StateProvider";
import db from "../firebase";

function Login() {
  const [state, dispatch] = useStateValue();
  const signIn = () => {
    //sign in
    auth
      .signInWithPopup(provider)
      .then((result) => {
        // console.log(result);
        dispatch({
          type: actionTypes.SET_USER,
          user: result.user,
        });

        const usersRef = db.collection(`users`).doc(result.user.uid);

        usersRef.get().then((doc) => {
          if (doc.exists) {
            console.log("users exist");
          } else {
            db.collection("users")
              .doc(result.user.uid)
              .set({
                name: result.user.displayName,
                username: result.user.displayName.replace(/ /g, "_"),
                location: "-",
                uid: result.user.uid,
                photoURL: result.user.photoURL,
              });
          }

          //   dispatch({
          //     type: actionTypes.SET_USER_PROFILE,
          //     userProfile: "test",
          //   });
        });
      })

      .catch((error) => alert(error.message));
  };

  return (
    <div className="login">
      <div className="login__logo">
        <h1>_Space</h1>
        <Button type="submit" onClick={signIn}>
          Sign In
        </Button>
      </div>
    </div>
  );
}

export default Login;
